import React from 'react';
import { Badge } from '@chakra-ui/react';
import { ArrowUp, ArrowDown, Minus } from 'phosphor-react';
import { KanbanPrioridade } from '../../hooks/useKanban';

interface KanbanPriorityBadgeProps {
  prioridade: KanbanPrioridade;
  size?: 'sm' | 'md';
}

const priorityConfig = {
  alta: {
    bg: 'red.200',
    color: 'red.800',
    label: 'Alta',
    icon: ArrowUp,
  },
  media: {
    bg: 'orange.200',
    color: 'orange.800',
    label: 'Media',
    icon: Minus,
  },
  baixa: {
    bg: 'green.200',
    color: 'green.800',
    label: 'Baixa',
    icon: ArrowDown,
  },
};

export const KanbanPriorityBadge: React.FC<KanbanPriorityBadgeProps> = ({
  prioridade,
  size = 'sm',
}) => {
  const config = priorityConfig[prioridade];
  const Icon = config.icon;
  const iconSize = size === 'sm' ? 10 : 12;

  return (
    <Badge
      bg={config.bg}
      color={config.color}
      fontSize={size === 'sm' ? '10px' : 'xs'}
      px={1.5}
      py={0.5}
      borderRadius="full"
      display="flex"
      alignItems="center"
      gap={1}
      textTransform="uppercase"
      fontWeight="600"
    >
      <Icon size={iconSize} weight="bold" />
      {config.label}
    </Badge>
  );
};
